<template>
  <div class="tw-my-4 md:tw-my-8">
    <v-card class="mx-auto tw-py-2 md:tw-py-4" outlined>
      <Inpatient :outlined="false" />
      <div class="tw-px-2 md:tw-px-8 tw-py-3 md:tw-py-6">
        <hr />
      </div>
      <div v-if="choice !== 'none'">
        <Maternity :choice="choice" />
        <div class="tw-px-2 md:tw-px-8 tw-py-3 md:tw-py-6">
          <hr />
        </div>
        <Outpatient :choice="choice" @toggle-outpatient-addons="toggleAddons" />
      </div>
      <transition
          name="fade"
          mode="out-in"
          appear
          :duration="500"
      >
        <div v-if="showOutpatientAddOns">
          <div class="tw-px-2 md:tw-px-8 tw-py-3 md:tw-py-6">
            <h2 class="c-navy-text tw-font-bold">Customise your outpatient  Optional Covers</h2>
          </div>
          <div class="tw-px-4 md:tw-px-10 tw-py-3 md:tw-py-3">
            <Dental />
          </div>
          <div class="tw-px-4 md:tw-px-10 tw-py-3 md:tw-py-3">
            <Optical />
          </div>
        </div>
      </transition>
      <div class="tw-px-3 md:tw-px-10 tw-py-3 tw-flex tw-flex-wrap tw-justify-between">
        <!-- <h2 class="c-navy-text tw-font-bold tw-text-xl md:tw-text-2xl">CURRENT LIMIT: Ksh {{ totalLimit }}</h2> -->
        <v-btn color="secondary" :loading="loading" @click="processQuote">Generate Quote</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import Inpatient from '@/components/rfq/health/components/Inpatient';
import Maternity from '@/components/rfq/health/components/Maternity';
import Outpatient from '@/components/rfq/health/components/Outpatient';
import Dental from '@/components/rfq/health/components/Dental';
import Optical from '@/components/rfq/health/components/Optical';
import helpers from '@/utils/helpers';
import axios from 'axios';

export default {
  name: 'SelectBenefitLimits',
  components: {
    Optical,
    Dental,
    Outpatient,
    Maternity,
    Inpatient,
  },
  props: ['choice'],
  data(vm) {
    return {
      showOutpatientAddOns: vm.choice === 'outpatient' || vm.choice === 'both',
      loading: false,
    };
  },
  computed: {
    totalLimit() {
      const quote = this.$store.getters['rfq/getHealthQuote'];
      let sum = 0;
      if (('inpatient_limit' in quote) && quote.inpatient_limit) sum += quote.inpatient_limit;
      if (('outpatient_limit' in quote) && quote.outpatient_limit) sum += quote.outpatient_limit;
      if (('maternity_limit' in quote) && quote.maternity_limit) sum += quote.maternity_limit;
      if (('dental_limit' in quote) && quote.dental_limit) sum += quote.dental_limit;
      if (('optical_limit' in quote) && quote.optical_limit) sum += quote.optical_limit;
      return helpers.numberToString(sum);
    },
  },
  methods: {
    toggleAddons(val) {
      this.showOutpatientAddOns = val;
    },
    async processQuote() {
      this.loading = true;
      const data = this.$store.getters['rfq/getHealthQuote'];
      Object.keys(data).forEach((key) => (data[key] === undefined ? delete data[key] : {}));
      await axios.post('/customer/digital-quotation/pacis-amani/quotes', data).then((response) => {
        this.$store.commit('rfq/setHealthQuoteResponse', response.data);
        this.$emit('proceed-to-health-quote');
      });
      this.loading = false;
    },
  },
};
</script>
